import * as z from 'zod';

import { LosId } from '../../BrandedIds';
import { zodBrandedString } from '../../utils';
import { InsuranceFields } from './sharedFields/InsuranceFields';

export const UpdateEscrowSettingsRow = z.object({
  loanId: zodBrandedString<LosId>(),
  ...InsuranceFields.shape,
});

export type UpdateEscrowSettingsRow = z.infer<typeof UpdateEscrowSettingsRow>;

export const UPDATE_ESCROW_SETTINGS_ROW_REQUIRED_FIELDS = Object.keys(UpdateEscrowSettingsRow.shape).filter(
  (key) => !UpdateEscrowSettingsRow.shape[key as keyof typeof UpdateEscrowSettingsRow.shape].isOptional(),
) as (keyof UpdateEscrowSettingsRow)[];
